import { render, staticRenderFns } from "./salary-register.vue?vue&type=template&id=a052938a&"
import script from "./salary-register.vue?vue&type=script&lang=js&"
export * from "./salary-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports